import { Loader } from '@calendly/ui/components/loader';
import classNames from 'classnames';
import { forwardRef } from 'react';
const containerCss = "c1niwxlh";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});
export const LoadingTile = () => <Container>
    <Loader data-testid="loader" />
  </Container>;

require("./loading_tile.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./loading_tile.js");